import React from 'react';
import { Play, Pause, RotateCw } from 'lucide-react';

type Props = { isLoading: boolean; isPlaying: boolean; onClick?: () => void };
export const PlayerControl = ({ isLoading, isPlaying, onClick }: Props) => {
  if (isLoading) {
    return (
      <Container>
        <RotateCw className="h-6 w-6 animate-spin text-white" />
      </Container>
    );
  }

  if (isPlaying) {
    return (
      <Container onClick={onClick}>
        <Pause className="h-6 w-6" fill="#fff" />
      </Container>
    );
  }

  return (
    <Container onClick={onClick}>
      <Play className="h-6 w-6" fill="#fff" />
    </Container>
  );
};

const Container = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div
      className="w-8 h-8 shrink-0 rounded cursor-pointer flex items-center justify-center"
      onClick={onClick}
    >
      {children}
    </div>
  );
};
